var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "form-group row mb-4" }, [
      _c(
        "label",
        { staticClass: "col-xl-3 col-lg-3 col-form-label text-right" },
        [_vm._v(_vm._s(_vm.category.name))]
      ),
      _vm._v(" "),
      _vm.taxonomiesList
        ? _c(
            "div",
            {
              staticClass:
                "col-xl-9 col-lg-9 dm-checkbox-email-options checkbox-list"
            },
            [
              _c(
                "label",
                {
                  staticClass: "checkbox font-weight-bolder",
                  class: _vm.partiallySelectedClass
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.allButtonChecked,
                        expression: "allButtonChecked"
                      }
                    ],
                    attrs: { type: "checkbox", checked: "checked" },
                    domProps: {
                      checked: Array.isArray(_vm.allButtonChecked)
                        ? _vm._i(_vm.allButtonChecked, null) > -1
                        : _vm.allButtonChecked
                    },
                    on: {
                      change: [
                        function($event) {
                          var $$a = _vm.allButtonChecked,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                (_vm.allButtonChecked = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.allButtonChecked = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.allButtonChecked = $$c
                          }
                        },
                        function($event) {
                          return _vm.toggleAll()
                        }
                      ]
                    }
                  }),
                  _vm._v(" "),
                  _c("span"),
                  _vm._v("All\n\t\t\t")
                ]
              ),
              _vm._v(" "),
              _vm._l(_vm.taxonomiesList, function(taxonomy) {
                return _c(
                  "label",
                  { key: "taxonomy-" + taxonomy.id, staticClass: "checkbox" },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.preferences[_vm.taxonomyType],
                          expression: "preferences[taxonomyType]"
                        }
                      ],
                      attrs: { type: "checkbox" },
                      domProps: {
                        value: taxonomy.id,
                        checked: Array.isArray(
                          _vm.preferences[_vm.taxonomyType]
                        )
                          ? _vm._i(
                              _vm.preferences[_vm.taxonomyType],
                              taxonomy.id
                            ) > -1
                          : _vm.preferences[_vm.taxonomyType]
                      },
                      on: {
                        change: [
                          function($event) {
                            var $$a = _vm.preferences[_vm.taxonomyType],
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = taxonomy.id,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.preferences,
                                    _vm.taxonomyType,
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.preferences,
                                    _vm.taxonomyType,
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.preferences, _vm.taxonomyType, $$c)
                            }
                          },
                          function($event) {
                            return _vm.handleChange()
                          }
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _c("span"),
                    _vm._v(_vm._s(taxonomy.name) + "\n\t\t\t")
                  ]
                )
              })
            ],
            2
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "separator separator-dashed my-10" })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }